export default __webpack_public_path__ + "static/media/arch.88b44d68.png";